import { useCallback } from 'react'
import { useDispatch, useSelector } from 'store'
import { inputF, selectF, voidF } from 'types/FunctionTypes'
import * as PageAction from 'slicers/PageSlice'
import * as SearchUserAction from 'slicers/SearchSlicers/SearchUserSlice'
import * as TableAction from 'slicers/TableSlicers/TableSlice'
import * as TableUserAction from 'slicers/TableSlicers/TableUserSlice'
import { baseInfo, searchUser, select } from 'types/SearchTypes'
import { responseUser } from 'utils/requestUtil'
import { postFetcher, response } from 'utils/apiUtil'

// 事業所コード入力 //================================//
export const useJigyoCd = (): [string, selectF] => {
  const dispatch = useDispatch()

  const JIGYO_CD = useSelector((state) => state.SearchUserReducer.searchJoken.JIGYO_CD)
  const changeJigyoCd = useCallback(
    (r: select) => {
      dispatch(SearchUserAction.changeJigyoCd(r))
    },
    [JIGYO_CD],
  )
  return [String(JIGYO_CD), changeJigyoCd]
}

// メールアドレス入力 //================================//
export const useMail = (): [string, selectF, boolean, inputF] => {
  const dispatch = useDispatch()

  const MAIL = useSelector((state) => state.SearchUserReducer.searchJoken.MAIL)
  const changeMail = useCallback(
    (r: select) => {
      dispatch(SearchUserAction.changeMail(r))
    },
    [MAIL],
  )
  const inclideKari = useSelector((state) => state.SearchUserReducer.searchJoken.inclideKari)
  const changeInclideKari = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(SearchUserAction.changeInclideKari(e.target.checked))
    },
    [MAIL],
  )
  return [String(MAIL), changeMail, inclideKari, changeInclideKari]
}

// 得意先コード入力 //================================//
export const useTokuiCd = (): [string, selectF] => {
  const dispatch = useDispatch()

  const TOKUI_CD = useSelector((state) => state.SearchUserReducer.searchJoken.TOKUI_CD)
  const changeTokuiCd = useCallback(
    (r: select) => {
      dispatch(SearchUserAction.changeTokuiCd(r))
    },
    [TOKUI_CD],
  )
  return [String(TOKUI_CD), changeTokuiCd]
}

// 店舗コード入力 //================================//
export const useTenCd = (): [string, selectF] => {
  const dispatch = useDispatch()

  const TEN_CD = useSelector((state) => state.SearchUserReducer.searchJoken.TEN_CD)
  const changeTenCd = useCallback(
    (r: select) => {
      dispatch(SearchUserAction.changeTenCd(r))
    },
    [TEN_CD],
  )
  return [String(TEN_CD), changeTenCd]
}

// ボタン項目押下処理 //================================//
export const useButtons = (): [voidF] => {
  const dispatch = useDispatch()
  const keyInfo = useSelector((state) => state.LoginReducer.keyInfo)
  const isSuper = useSelector((state) => state.LoginReducer.isSuper)

  // 検索条件リセットボタン押下処理 //================================//
  const clickReset = useCallback(() => {
    dispatch(PageAction.format())
    if (isSuper) dispatch(SearchUserAction.changeJigyoCd({ value: String(keyInfo[0].JIGYO_CD), label: '' }))
    dispatch(SearchUserAction.initialize({ isSuper: isSuper, JIGYO_CD: keyInfo[0].JIGYO_CD })) // 初期状態に設定
    dispatch(TableUserAction.format())
    dispatch(TableAction.format())
  }, [keyInfo])

  return [clickReset]
}

// 初期状態設定 //================================//
export const useInit = (): voidF => {
  const dispatch = useDispatch()

  const isSuper = useSelector((state) => state.LoginReducer.isSuper)
  const JIGYO_CD = useSelector((state) => state.LoginReducer.keyInfo[0].JIGYO_CD)
  return useCallback(() => {
    if (isSuper) dispatch(SearchUserAction.changeJigyoCd({ value: String(JIGYO_CD), label: '' }))
  }, [JIGYO_CD])
}

// サマリフェッチャー //================================//
type fetchResp = { pullDown: baseInfo; table: responseUser[] }
export const useFetcher = (): [searchUser, () => Promise<response<fetchResp>>] => {
  const searchJoken = useSelector((state) => state.SearchUserReducer.searchJoken)
  return [searchJoken, postFetcher<fetchResp>('postUserInfo', searchJoken)]
}
